import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { getBackend } from "../../api/backend";
import { CircularProgress } from "@mui/material";

export default function TaskTypeChart() {
  const [chartData, setChartData] = useState({ labels: [], data: {} });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getBackend("task-type-chart-data");

        // Manejar labels y data correctamente
        const filteredLabels = data.labels.filter((label, index) => {
          return Object.values(data.data).some(
            (categoryData) => categoryData.data[index] > 0
          );
        });

        const filteredData = Object.keys(data.data).reduce((acc, key) => {
          acc[key] = {
            data: data.data[key].data.filter((_, index) =>
              Object.values(data.data).some(
                (categoryData) => categoryData.data[index] > 0
              )
            ),
            color: data.data[key].color, // Incluir color desde los datos del backend
          };
          return acc;
        }, {});

        setChartData({ labels: filteredLabels, data: filteredData });
      } catch (error) {
        console.error("Error fetching the chart data", error);
      }
    };

    fetchData().then(() => setIsLoading(false));
  }, []);

  // Crear series a partir de los datos procesados
  const filteredSeries = Object.keys(chartData.data).map((key) => ({
    data: chartData.data[key].data,
    label: key,
    id: key,
    stack: "total",
    color: chartData.data[key].color, // Aplicar color desde la respuesta del backend
  }));

  return isLoading ? <CircularProgress/> : (
    <BarChart
      width={850}
      height={350}
      series={filteredSeries}
      xAxis={[
        {
          data: chartData.labels,
          scaleType: "band",
          label: "Meses",
        },
      ]}
      borderRadius={8}
    />
  );
}
